module.exports = __webpack_public_path__ + "static/media/06-min.c67ef5f9.png";